"use client";

import { createBrowserClient } from "@supabase/ssr";

/**
 * クライアントサイド用の Supabase クライアント。
 * セッションをクッキーに自動保存する。
 */
export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      // getUser 等の Supabase Auth への fetch が hang/無応答だと
      // クライアントが固まり "Failed to fetch" を多発させる (#126)。
      // 既存の signal (Supabase 内部の abort) を尊重しつつ、無ければ 8s timeout を付ける。
      global: {
        fetch: ((input: RequestInfo | URL, init?: RequestInit) =>
          fetch(input, {
            ...init,
            signal: init?.signal ?? AbortSignal.timeout(8000),
          })) as typeof fetch,
      },
    }
  );
}
